/*

Envy by WeTheme (http://www.wetheme.com)
Custom JS

Last Update:
2nd December 2014
- Added Sidr code

*/

// Mobile Browser Menu

$("select#mobile-menu").change(function() {
  window.location = $(this).find("option:selected").val();
});

// Zoom!

$(document).ready(function(){
  $('.featured-image-div').zoom();		
  $('a.image-swap').click(function() {
    var newImage = $(this).attr('href');
    $( '.featured-image-div img' ).attr({ src: newImage }); 
    return false;
  });
  
});

// FancyBox

$(document).ready(function() {
	$(".fancybox").fancybox();
});

$(document).ready(function() {
	$(".fancybox-instagram").fancybox({
		padding : 0
	});
});

// Login Boxes

$("#forgot-password-box").click(function(){
    $("#customer-login").hide();
    $("#recover-password").show();
});

$("#login-box-link").click(function(){
	$("#customer-login").show();
	$("#recover-password").hide();
});

// MatchHeight

$(function() {
    $('.homepage-collection-grid-inner .grid-image').matchHeight();
});

// Sidr

$(document).ready(function() {
	$('.slide-menu').sidr({
      name: 'sidr',
      side: 'right'
    });
	$('#sidr').show();
});

// Flexslider Mobile Product Images

$(window).load(function() {
	$('.mobile-product-slider').flexslider({
		animation: 'slide',
		directionNav: false,
		controlNav: true,
		startAt: 0,
		slideshow: false
  });
});

// Mobile Menu

jQuery(document).ready(function( $ ) {
    $("#menu").mmenu({
    	navbar: {
    		title: ""
    	}
    });
 });